<template>
  <el-row
    v-loading="loading"
    class="home-container"
  >
    <div class="base-wrapper sell-faster">
      <el-button
        class="primary-button close"
        icon="icon-x"
        @click="$router.push({ name: 'Home' })"
      />
      <div class="header-wrapper">
        <i class="icon-favorites" />
        <div class="inner">
          <h1 class="title">
            {{ $t('feature-ad.sell-faster.title') }}
          </h1>
          <span class="sub-title">{{ $t( 'feature-ad.sell-faster.subtitle' ) }}</span>
          <span class="ad-id">{{ $t( 'feature-ad.sell-faster.ad-id' ) }} <strong>{{ $route.params.id }}</strong></span>
        </div>
        <i class="icon-favorites second" />
      </div>
      <div class="feature-input-wrapper">
        <el-form
          v-loading.fullscreen.lock="loading"
          :model="form"
          @submit.native.prevent="onSubmit"
        >
          <el-form-item :error="error('phone')">
            <span class="primary-label">{{ $t('feature-ad.sell-faster.phone.label') }}</span>
            <el-input
              v-model="form.phone"
              class="input-primary"
              @change="change('phone')"
            />
          </el-form-item>
          <el-form-item :error="error('email')">
            <span class="primary-label">{{ $t('feature-ad.sell-faster.email.label') }}</span>
            <el-input
              v-model="form.email"
              class="input-primary"
            />
          </el-form-item>
          <el-form-item :error="error('message')">
            <span class="primary-label">{{ $t('feature-ad.sell-faster.message.label') }}</span>
            <el-input
              v-model="form.message"
              class="input-primary"
              type="textarea"
              :autosize="{ minRows: 3 }"
            />
          </el-form-item>
        </el-form>
      </div>
      <el-button
        class="primary-button submit"
        @click="onSubmit"
      >
        {{ $t('feature-ad.sell-faster.send.text') }}
      </el-button>
    </div>
  </el-row>
</template>

<script>
import { mapState } from 'vuex';
import { dataGet } from '@fps/vue-toolkit/dist/util';
import ResourcePage from '../components/Core/ResourcePage';

export default {
  extends: ResourcePage,
  data() {
    return {
      resource: 'contact-messages',
    };
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      user: state => state.auth.user,
    }),
  },
  created() {
    this.form.phone = dataGet('user.contact_info.phone', this, '');
    this.form.email = dataGet('user.email', this, '');
    this.form.message = this.$t('feature-ad.sell-faster.description', { adId: this.$route.params.id });
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.provider.add({
        user_id: this.user.id,
        ad_id: this.$route.params.id,
        ...this.form,
      })
        .then(() => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: this.$t('message.success'),
            type: 'success',
          });
          this.$router.push({ name: 'Congratulations' });
        })
        .catch(({ response }) => {
          this.onFormError(response);
        });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/FeatureAd.vue